/**
 * Action Types
 */

export const Types = {
    ADD: 'ADD_TOAST',
    REMOVE: 'REMOVE_TOAST',
    REMOVE_ALL: 'REMOVE_ALL'
};

/**
 * Reducer
 */
const INITIAL_STATE = [];

export default function toast(state = INITIAL_STATE, action) {
    const { payload, type } = action;

    switch (type) {
        case Types.ADD:
            payload.id = state.length + 1;

            return [payload, ...state];

        case Types.REMOVE:
            return state.filter((toast) => toast.id !== payload);

        case Types.REMOVE_ALL:
            return INITIAL_STATE;

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    addToast: (payload) => ({
        type: Types.ADD,
        payload
    }),

    removeToast: (id) => ({
        payload: id,
        type: Types.REMOVE
    }),

    removeAllToast: () => ({
        type: Types.REMOVE_ALL
    })
};
